import { parseDocumentFromString, serializeDocument } from 'anodum';
import template from '../../template';
import actionTypes from '../constants/action-types';
import selectors from '../selectors';
import verifiers from '../verifiers';
import createPage from '../actions/create-page';
import setActivePage from '../actions/set-active-page';
import replaceTitleInHtml from '../helpers/replace-title-in-html';
import getCurrentLocale from '../../site-locales/selectors/current-locale';
import isFunction from '../../../utils/is-function';

const pageCreator = (store) => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.CREATE_PAGE_FROM_TEMPLATE: {
      const {
        pageModifier,
        pageTemplateId,
        title,
        displayInNavigation,
        skipActivePageChange,
        displayBusinessName,
        parentFolderId,
      } = action.payload;
      const state = store.getState();

      const pageTemplate = template.selectors.getPageTemplate(state, pageTemplateId);

      if (!pageTemplate) {
        next(action);
        break;
      }

      const { html, usedBlocks } = pageTemplate;
      const targetHTML = replaceTitleInHtml(html, title);
      const targetDocument = parseDocumentFromString(targetHTML);

      if (isFunction(pageModifier)) pageModifier(targetDocument);

      const activeLocale = getCurrentLocale(state);

      store.dispatch(
        createPage({
          html: serializeDocument(targetDocument),
          locale: activeLocale,
          displayInNavigation,
          usedBlocks,
          pageTemplateId,
          isMultilingualSite: verifiers.isMultilingualSite(),
          name: title,
          skipActivePageChange,
          displayBusinessName,
          parentFolderId,
        })
      );
      next(action);

      break;
    }

    case actionTypes.COPY_PAGE:
    case actionTypes.CREATE_PAGE: {
      next(action);

      if (action.payload.skipActivePageChange) {
        break;
      }

      const state = store.getState();
      const newPage = selectors.getPage(state, action.payload.pageId);
      store.dispatch(setActivePage(newPage.id));

      break;
    }

    default:
      next(action);
  }
};

export default pageCreator;
